import usePendingState from '../../Hooks/usePendingState';
import { InputMask } from '@react-input/mask';
import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Select from 'react-select';

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNotification } from '../../Contexts/NotificationContext';
import Loading from '../Loading';

export const FormEditMember = () => {
    const { setNotification } = useNotification();
    const [loading, setLoading] = useState(true);
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [memberData, setMemberData] = useState({
        nome: '',
        email: '',
        password: '',
        cnpj: '',
        razao_social: '',
        pais: '',
        cidade: '',
        cidade_texto: '',
        estado: '',
        data_nascimento: '',
    });

    const [memberErrorData, setMemberErrorData] = useState({
        nome: [],
        email: [],
        password: [],
        cnpj: [],
        razao_social: [],
        telefone: [],
        pais: [],
        cidade: [],
        cidade_texto: [],
        estado: [],
        data_nascimento: [],
    });

    const [formLoading, setFormLoading, formPendingRef] = usePendingState();

    const navigate = useNavigate();
    const { id } = useParams();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setMemberData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleStateChange = async (selectedOption, isFetch = false) => {
        setMemberData((prevData) => ({
            ...prevData,
            estado: selectedOption.value,
            cidade: isFetch ? prevData.cidade : '',
        }));
        setMemberErrorData((prevData) => ({
            ...prevData,
            estado: [],
            cidade: [],
        }));

        const response = await fetch(`${baseUrl}/manager/estados/${selectedOption.value}/cidades/`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
        });
        if (response.ok) {
            const data = await response.json();
            setCities(data.cidades);
        }
    };

    const handleCityChange = (selectedOption) => {
        setMemberData((prevData) => ({
            ...prevData,
            cidade: selectedOption.value,
        }));
        setMemberErrorData((prevData) => ({
            ...prevData,
            cidade: [],
        }));
    };

    const handleCountryChange = (selectedOption) => {
        setMemberData((prevData) => ({
            ...prevData,
            pais: selectedOption.value,
        }));
        setMemberErrorData((prevData) => ({
            ...prevData,
            pais: [],
        }));
    };

    useEffect(() => {
        const fetchContent = async () => {
            const [memberResponse, countriesResponse, statesResponse] = await Promise.all([
                fetch(`${baseUrl}/manager/internos/${id}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                }),
                fetch(`${baseUrl}/manager/paises/`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                }),
                fetch(`${baseUrl}/manager/estados/`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        'Content-Type': 'application/json',
                    },
                }),
            ]);

            if (countriesResponse.ok) {
                const countriesData = await countriesResponse.json();
                setCountries(countriesData.paises);
            } else {
                setNotification({
                    type: 'error',
                    message: 'Erro ao buscar paises.',
                    show: true,
                });
            }

            if (memberResponse.ok) {
                const memberData = await memberResponse.json();
                console.log(memberData.interno);
                setMemberData((prev) => ({
                    ...prev,
                    ...memberData.interno,
                }));
            }

            if (statesResponse.ok) {
                const statesData = await statesResponse.json();
                setStates(statesData.estados);
            }
        };

        fetchContent();
    }, []);

    useEffect(() => {
        if (states.length > 0 && memberData.estado) {
            const selectedOption = states.find((state) => state.value === memberData.estado);
            if (selectedOption) {
                handleStateChange(selectedOption, true);

                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    }, [states, memberData.estado]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formPendingRef.current) return;
        setFormLoading(true);

        try {
            const response = await fetch(`${baseUrl}/manager/internos/atualizar/${id}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify(memberData),
            });
            if (response.ok) {
                setNotification({
                    type: 'success',
                    message: 'Usuário adicionado com sucesso!',
                    show: true,
                });
                navigate('/manager/usuarios-internos');
            } else {
                if (response.status === 422) {
                    const errors = await response.json();

                    setMemberErrorData(errors);
                } else {
                    throw new Error('Erro ao atualizar interno.');
                }
            }
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setFormLoading(false);
        }
    };

    if (loading)
        return (
            <div className="mx-auto py-20 flex justify-center">
                <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-primary border-t-transparent"></div>
            </div>
        );

    return (
        <>
            <Link
                to="/manager/usuarios-internos"
                className="bg-slate-100 px-4 py-1.5 rounded border border-slate-300 float-right ml-2 transition-all hover:bg-slate-200"
            >
                <FontAwesomeIcon icon={faArrowLeft} className="mr-2" />
                Voltar
            </Link>

            <h4 className="mb-6 text-xl font-bold text-black">Editar usuário</h4>

            <div className="flex flex-col">
                <form onSubmit={handleSubmit} className="max-w-5xl pb-10">
                    <div className="mb-6 2xl:mb-10">
                        <div className="mb-3 flex gap-5 flex-col lg:flex-row w-full lg:w-3/4">
                            <div className="w-full">
                                <label className="block text-sm font-medium mb-1">Nome</label>
                                <input
                                    type="text"
                                    name="nome"
                                    value={memberData.nome}
                                    onClick={() => setMemberErrorData((prevData) => ({ ...prevData, nome: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {memberErrorData.nome && memberErrorData.nome[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {memberErrorData.nome[0]}{' '}
                                        <span
                                            onClick={() => setMemberErrorData((prevData) => ({ ...prevData, nome: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="mb-3 flex gap-5 flex-col lg:flex-row w-full lg:w-3/4">
                            <div className="w-1/2">
                                <label className="block text-sm font-medium mb-1">E-mail</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={memberData.email}
                                    onClick={() => setMemberErrorData((prevData) => ({ ...prevData, email: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {memberErrorData.email && memberErrorData.email[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {memberErrorData.email[0]}{' '}
                                        <span
                                            onClick={() => setMemberErrorData((prevData) => ({ ...prevData, email: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>

                            <div className="w-1/2">
                                <label className="block text-sm font-medium mb-1">Senha</label>
                                <input
                                    type="password"
                                    name="password"
                                    value={memberData.password}
                                    onClick={() => setMemberErrorData((prevData) => ({ ...prevData, password: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {memberErrorData.password && memberErrorData.password[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {memberErrorData.password[0]}{' '}
                                        <span
                                            onClick={() => setMemberErrorData((prevData) => ({ ...prevData, password: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="mb-3 flex gap-5 flex-col lg:flex-row w-full lg:w-3/4">
                            <div className="w-1/2">
                                <label className="block text-sm font-medium mb-1">Telefone</label>
                                <InputMask
                                    type="text"
                                    name="telefone"
                                    mask="(__) _____-____"
                                    replacement={{ _: /\d/ }}
                                    value={memberData.telefone}
                                    onClick={() => setMemberErrorData((prevData) => ({ ...prevData, telefone: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {memberErrorData.telefone && memberErrorData.telefone[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {memberErrorData.telefone[0]}{' '}
                                        <span
                                            onClick={() => setMemberErrorData((prevData) => ({ ...prevData, telefone: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>

                            <div className="w-1/2">
                                <label className="block text-sm font-medium mb-1">Data de Nascimento</label>
                                <input
                                    type="date"
                                    name="data_nascimento"
                                    value={memberData.data_nascimento}
                                    onClick={() => setMemberErrorData((prevData) => ({ ...prevData, data_nascimento: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                    max={new Date().toJSON().slice(0, 10)}
                                />
                                {memberErrorData.data_nascimento && memberErrorData.data_nascimento[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {memberErrorData.data_nascimento[0]}{' '}
                                        <span
                                            onClick={() => setMemberErrorData((prevData) => ({ ...prevData, data_nascimento: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>

                        <div className="mb-3 flex gap-5 flex-col lg:flex-row w-full lg:w-3/4">
                            <div className={`transition-all ${memberData.pais === 4 || memberData.pais === '' ? 'lg:w-1/3' : 'lg:w-1/2'}`}>
                                <label className="block text-sm font-medium mb-1">País</label>
                                <Select
                                    name="pais"
                                    options={countries}
                                    value={countries.find((option) => option.value === memberData.pais) || null}
                                    onClick={() => setMemberErrorData((prevData) => ({ ...prevData, pais: [] }))}
                                    onChange={handleCountryChange}
                                    placeholder="Selecione um país..."
                                    classNamePrefix="admin-select"
                                    className="member-select"
                                />
                                {memberErrorData.pais && memberErrorData.pais[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {memberErrorData.pais[0]}{' '}
                                        <span
                                            onClick={() => setMemberErrorData((prevData) => ({ ...prevData, pais: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>

                            <div
                                className={`w-full flex gap-5 flex-row transition-all ${memberData.pais === 4 || memberData.pais === '' ? 'lg:w-2/3' : 'lg:w-1/2'}`}
                            >
                                <div
                                    className={`w-full lg:w-1/2 max-h-8 transition-all ${memberData.pais === 4 || memberData.pais === '' ? 'max-lg:max-h-16 lg:max-w-72' : 'max-w-0 overflow-hidden -ml-5'}`}
                                >
                                    <label className="block text-sm font-medium mb-1">Estado</label>
                                    <Select
                                        name="estado"
                                        options={states}
                                        value={states.find((option) => option.value === memberData.estado) || null}
                                        onClick={() => setMemberErrorData((prevData) => ({ ...prevData, estado: [] }))}
                                        onChange={handleStateChange}
                                        placeholder="Selecione um estado..."
                                        classNamePrefix="admin-select"
                                        className="member-select"
                                        isDisabled={memberData.pais === ''}
                                    />
                                    {memberErrorData.estado && memberErrorData.estado[0] && (
                                        <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                            {memberErrorData.estado[0]}{' '}
                                            <span
                                                onClick={() => setMemberErrorData((prevData) => ({ ...prevData, estado: [] }))}
                                                className="rotate-45 -my-2 p-2 cursor-pointer"
                                            >
                                                +
                                            </span>
                                        </span>
                                    )}
                                </div>
                                <div
                                    className={`transition-all ${memberData.pais === 4 || memberData.pais === '' ? 'w-full lg:w-1/2' : 'w-full'}`}
                                >
                                    <label className="block text-sm font-medium mb-1">Cidade</label>
                                    {memberData.pais === 4 || memberData.pais === '' ? (
                                        <>
                                            <Select
                                                name="cidade"
                                                options={cities}
                                                value={cities.find((option) => option.value === memberData.cidade) || null}
                                                onClick={() => setMemberErrorData((prevData) => ({ ...prevData, cidade: [] }))}
                                                onChange={handleCityChange}
                                                placeholder={!memberData.estado ? 'Selecione o estado' : 'Selecione uma cidade...'}
                                                classNamePrefix="admin-select"
                                                className="member-select"
                                                isDisabled={cities.length === 0}
                                            />

                                            {memberErrorData.cidade && memberErrorData.cidade[0] && (
                                                <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                                    {memberErrorData.cidade[0]}{' '}
                                                    <span
                                                        onClick={() => setMemberErrorData((prevData) => ({ ...prevData, cidade: [] }))}
                                                        className="rotate-45 -my-2 p-2 cursor-pointer"
                                                    >
                                                        +
                                                    </span>
                                                </span>
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            <input
                                                type="text"
                                                name="cidade_texto"
                                                value={memberData.cidade_texto}
                                                onClick={() => setMemberErrorData((prevData) => ({ ...prevData, cidade_texto: [] }))}
                                                onChange={handleChange}
                                                className="w-full px-3 py-1.5 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                            />

                                            {memberErrorData.cidade_texto && memberErrorData.cidade_texto[0] && (
                                                <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                                    {memberErrorData.cidade_texto[0]}{' '}
                                                    <span
                                                        onClick={() =>
                                                            setMemberErrorData((prevData) => ({ ...prevData, cidade_texto: [] }))
                                                        }
                                                        className="rotate-45 -my-2 p-2 cursor-pointer"
                                                    >
                                                        +
                                                    </span>
                                                </span>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="mb-3 flex gap-5 flex-col lg:flex-row">
                            <div className="w-1/3">
                                <label className="block text-sm font-medium mb-1">CNPJ</label>
                                <InputMask
                                    type="text"
                                    name="cnpj"
                                    mask="__.___.___/____-__"
                                    replacement={{ _: /\d/ }}
                                    value={memberData.cnpj}
                                    onClick={() => setMemberErrorData((prevData) => ({ ...prevData, cnpj: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {memberErrorData.cnpj && memberErrorData.cnpj[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {memberErrorData.cnpj[0]}{' '}
                                        <span
                                            onClick={() => setMemberErrorData((prevData) => ({ ...prevData, cnpj: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>

                            <div className="w-1/3">
                                <label className="block text-sm font-medium mb-1">Razão Social</label>
                                <input
                                    type="text"
                                    name="razao_social"
                                    value={memberData.razao_social}
                                    onClick={() => setMemberErrorData((prevData) => ({ ...prevData, razao_social: [] }))}
                                    onChange={handleChange}
                                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                                />
                                {memberErrorData.razao_social && memberErrorData.razao_social[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {memberErrorData.razao_social[0]}{' '}
                                        <span
                                            onClick={() => setMemberErrorData((prevData) => ({ ...prevData, razao_social: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>

                            <div className="w-1/6">
                                <label className="block text-sm font-medium mb-1">Ativo?</label>

                                <label className="cursor-pointer">
                                    <input
                                        type="checkbox"
                                        name="ativo"
                                        checked={memberData.ativo}
                                        onChange={handleChange}
                                        className="sr-only peer"
                                    />
                                    <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-0 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-green-600"></div>
                                </label>

                                {memberErrorData.ativo && memberErrorData.ativo[0] && (
                                    <span className="flex justify-between border-b border-red-500 text-xs 2xl:text-sm text-red-500 tracking-tight 2xl:tracking-normal mt-1 pb-1 pl-2">
                                        {memberErrorData.ativo[0]}{' '}
                                        <span
                                            onClick={() => setMemberErrorData((prevData) => ({ ...prevData, ativo: [] }))}
                                            className="rotate-45 -my-2 p-2 cursor-pointer"
                                        >
                                            +
                                        </span>
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>

                    <button
                        type="submit"
                        disabled={formLoading}
                        aria-busy={formLoading}
                        className="w-full lg:w-3/4 bg-secondary text-white py-2 px-4 rounded-md hover:bg-opacity-80 disabled:bg-opacity-80 disabled:cursor-not-allowed"
                    >
                        {!formLoading ? 'Salvar' : <Loading />}
                    </button>
                </form>
            </div>
        </>
    );
};
